import { useMemo } from 'react';
import { getEligibleAdultPrimaryPassengers } from '@/app/(main)/client-detail/utils/getEligibleAdultPrimaryPassengers';
import type { Optional } from '@/types/common';
import { useGetClientDetailsQuery } from '../useGetClientDetailsQuery';
import { useGetRelatedTravelersQuery } from '../useGetRelatedTravelersQuery';

export type UseEligibleAdultPrimaryPassengersParams = {
  excludeClientId?: Optional<number>;
  enabled?: boolean;
};

export function useEligibleAdultPrimaryPassengers({
  excludeClientId,
  enabled = true,
}: UseEligibleAdultPrimaryPassengersParams = {}) {
  const { data: currentClientResponse } = useGetClientDetailsQuery();
  const { data: relatedTravelersResponse } = useGetRelatedTravelersQuery({ enabled });

  return useMemo(
    () =>
      enabled
        ? getEligibleAdultPrimaryPassengers({
            currentClient: currentClientResponse?.data,
            relatedTravelers: relatedTravelersResponse?.data ?? [],
            excludeClientId,
          })
        : [],
    [currentClientResponse?.data, enabled, excludeClientId, relatedTravelersResponse?.data]
  );
}
